import "./ApprovedRuleDetails.css";
import { useState, useEffect } from "react"; // ADDED
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  getApproveORFailRules,
  getEnvironmentOptions,
  PublishTestRule,
} from "../TestRule/TestRuleRedux";
import { viewCodeAssistRules } from "../ViewRuleDatabase/Redux/ruleDatabaseSlice";
import Select from "react-select";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const DEFAULT_RULE = {
  id: "RUL-1042",
  title: "High-Risk Pregnancy Aspirin Prophylaxis",
  description: "High-Risk Pregnancy Aspirin Prophylaxis",
  createdBy: "Zoe .H",
  createdOn: "Oct 24, 2023",
  submittedForTesting: "Oct 26, 2023",
  pathwayEntity: "OB/GYN Intake",
  triggerCodes: ["O09.89", "Z33.1"],
  configuredGuidance: "Consider Aspirin Prophylaxis for High-Risk Pregnancy.",
  recommendedAction: "Review and apply the recommended clinical guidance.",
  testStatus: "Passed",
  testedBy: "Zoe .H",
  testedOn: "Oct 26, 2023, 14:45 EST",
  approvalStatus: "Approved",
  approvedBy: "Zoe .H",
  approvedOn: "Oct 26, 2023, 14:50 EST",
};

export default function ApprovedRuleDetails({
  rule = DEFAULT_RULE,
  onBack,
  onPublish,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const ruleId = searchParams.get("code_assist_manual_rule_id");
  const ruleAction = searchParams.get("action");
  const ruleReason = searchParams.get("reason");

  // ===== ADDED: modal state =====
  const [showPublishModal, setShowPublishModal] = useState(false);
  const [environment, setEnvironment] = useState([]);
  const [environmentError, setEnvironmentError] = useState("");

  let {
    loading: approveORFailRulesLoading,
    data: approveORFailRulesData,
    error: approveORFailRulesError,
  } = useSelector((state) => state.testRule.approveORFailRules);

  const {
    loading: environmentOptionsLoading,
    data: environmentOptionsData,
    error: environmentOptionsError,
  } = useSelector((state) => state.testRule.environmentOptions);

  const { ruleDraft } = useSelector((state) => state.ruleDatabase);
  if (!ruleAction) {
    approveORFailRulesData = ruleDraft;
  }

  const handleBack = () => {
    if (onBack) return onBack();
    navigate("/view-rule-database");
  };

  const handleConfirmPublish = async () => {

    if (!environment || environment.length === 0) {
    setEnvironmentError("Please select at least one environment.");
    return;
  }

  setEnvironmentError("");
    try {
      const publishRulePayload = {
        code_assist_manual_rule_id:
          approveORFailRulesData?.code_assist_manual_rule_id || "",
        environment,
      };

      setShowPublishModal(false);
      const queryParams = new URLSearchParams({
        code_assist_manual_rule_id:
          publishRulePayload?.code_assist_manual_rule_id,
        environment: JSON.stringify(environment),
      });

      navigate(`/published-rule-details?${queryParams.toString()}`);
    } catch (error) {
      console.error("Failed to publish rule:", error);
    }
  };

  const handleRuleDraft = () => {
    setShowPublishModal(false);
    navigate("/view-rule-database");
  };

  useEffect(() => {
    dispatch(getEnvironmentOptions());
  }, [dispatch]);

  useEffect(() => {
    if (!ruleId) return;

    const fetchRuleDetails = async () => {
      try {
        if (ruleAction) {
          const payload = {
            code_assist_manual_rule_id: ruleId,
            action: ruleAction,
            reason: ruleReason || "",
          };
          const result = await dispatch(
            getApproveORFailRules(payload),
          ).unwrap();
        } else {
          const result = await dispatch(
            viewCodeAssistRules({ code_assist_manual_rule_id: ruleId }),
          ).unwrap();
        }
      } catch (error) {
        console.error("Failed to get rule details:", error);
      }
    };

    fetchRuleDetails();
  }, [dispatch, ruleId, ruleAction, ruleReason]);

  const environmentOptions =
    environmentOptionsData?.environments?.map((env) => ({
      label: env,
      value: env,
    })) || [];

 const environmentAvailable =
  sessionStorage.getItem("environment-available") || "";

const deployedEnvs = Array.isArray(environmentAvailable)
  ? environmentAvailable
  : environmentAvailable
      .split(",")
      .map((env) => env.trim())
      .filter(Boolean);
  return (
    <div className="approvedRule-page">
      {/* Header */}
      <div className="approvedRule-header">
        <div className="approvedRule-header-title-row">
          <h1 className="approvedRule-title">
            {approveORFailRulesLoading
              ? "Description..."
              : approveORFailRulesData?.description
                ? approveORFailRulesData?.description
                : "No Title"}
          </h1>
          <span className="approvedRule-id-pill">
            {approveORFailRulesLoading
              ? "Rule ID..."
              : approveORFailRulesData?.rule_id
                ? approveORFailRulesData?.rule_id
                : "No Rule ID"}
          </span>
          <span className="approvedRule-status-badge approvedRule-status-badge--approved">
            Approved
          </span>
        </div>
      </div>

      {/* Rule Information */}
      <section className="approvedRule-card">
        <div className="approvedRule-card-header">Rule Information</div>
        <div className="approvedRule-card-body">
          <div className="approvedRule-grid">
            <div className="approvedRule-field">
              <div className="approvedRule-label">Rule ID</div>
              <div className="approvedRule-value">
                {approveORFailRulesLoading
                  ? "Loading..."
                  : approveORFailRulesData?.rule_id
                    ? approveORFailRulesData?.rule_id
                    : "-"}
              </div>
            </div>
            <div className="approvedRule-field">
              <div className="approvedRule-label">Rule Description</div>
              <div className="approvedRule-value">
                {approveORFailRulesLoading
                  ? "Loading..."
                  : approveORFailRulesData?.description
                    ? approveORFailRulesData.description
                    : "-"}
              </div>
            </div>

            <div className="approvedRule-field">
              <div className="approvedRule-label">Created By</div>
              <div className="approvedRule-value">
                {approveORFailRulesLoading ? (
                  "Loading..."
                ) : (
                  <>
                    <span className="approvedRule-value--strong">
                      {approveORFailRulesData?.rule_information?.created_by ||
                        "-"}
                    </span>{" "}
                    <span className="approvedRule-value--muted">
                      {approveORFailRulesData?.rule_information?.created_on ||
                        "-"}
                    </span>
                  </>
                )}
              </div>
            </div>
            <div className="approvedRule-field">
              <div className="approvedRule-label">Submitted For Testing</div>
              <div className="approvedRule-value">
                {approveORFailRulesLoading
                  ? "Loading..."
                  : approveORFailRulesData?.message
                    ? approveORFailRulesData?.message
                    : "-"}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Rule Configuration */}
      {/* Rule Configuration */}
      <section className="approvedRule-card">
        <div className="approvedRule-card-header">Rule Configuration</div>

        <div className="approvedRule-card-body">
          {/* Pathway Entry Point */}
          <div className="approvedRule-field">
            <div className="approvedRule-label">Pathway Entry Point</div>

            <div className="approvedRule-value">
              {approveORFailRulesLoading
                ? "Loading..."
                : approveORFailRulesData?.rule_configuration?.pathway_entry
                  ? `${approveORFailRulesData.rule_configuration.pathway_entry.type || "-"}${
                      approveORFailRulesData.rule_configuration.pathway_entry
                        .value
                        ? ` - ${approveORFailRulesData.rule_configuration.pathway_entry.value}`
                        : ""
                    }`
                  : "-"}
            </div>
          </div>

          {/* Trigger Codes */}
          <div className="approvedRule-field approvedRule-field--spaced">
            <div className="approvedRule-label">Trigger Code(s)</div>

            <div className="approvedRule-tags">
              {approveORFailRulesLoading ? (
                "Loading..."
              ) : approveORFailRulesData?.rule_configuration?.trigger_codes
                  ?.length > 0 ? (
                approveORFailRulesData.rule_configuration.trigger_codes.map(
                  (item, index) => (
                    <span
                      className="viewActiveRule-tag"
                      key={`${item?.code || "code"}-${index}`}
                    >
                      <span className="viewActiveRule-tag-code">
                        {item?.code || "-"}
                      </span>

                      <span className="viewActiveRule-tag-desc">
                        {item?.description || "-"}
                      </span>
                    </span>
                  ),
                )
              ) : (
                <span className="viewActiveRule-value">No trigger codes.</span>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Guidance & Decision Support */}
      <section className="approvedRule-card">
        <div className="approvedRule-card-header">
          Guidance &amp; Decision Support
        </div>
        <div className="approvedRule-card-body">
          <div className="approvedRule-label">Configured Guidance</div>
          <div className="approvedRule-guidance-box">
            &ldquo;
            {approveORFailRulesLoading
              ? "Loading..."
              : approveORFailRulesData?.guidance_decision_support
                    ?.configured_guidance
                ? approveORFailRulesData?.guidance_decision_support
                    ?.configured_guidance
                : "-"}
            &rdquo;
          </div>

          <div className="approvedRule-label approvedRule-label--spaced">
            Recommended Action
          </div>
          <div className="approvedRule-value">
            {approveORFailRulesLoading
              ? "Loading..."
              : approveORFailRulesData?.guidance_decision_support
                    ?.recommended_action
                ? approveORFailRulesData?.guidance_decision_support
                    ?.recommended_action
                : "-"}
          </div>
        </div>
      </section>

      {/* Testing Result + Approval Information */}
      <div className="approvedRule-splitRow">
        <section className="approvedRule-card approvedRule-card--half">
          <div className="approvedRule-card-header">Testing Result</div>
          <div className="approvedRule-card-body">
            <div className="approvedRule-grid approvedRule-grid--tight">
              <div className="approvedRule-field">
                <div className="approvedRule-label">Test Status</div>
                <div className="approvedRule-value approvedRule-value--success">
                  <span className="approvedRule-successDot" aria-hidden="true">
                    &#10003;
                  </span>
                  {approveORFailRulesLoading
                    ? "Loading..."
                    : approveORFailRulesData?.testing_information?.test_status
                      ? approveORFailRulesData?.testing_information?.test_status
                      : "-"}
                </div>
              </div>
              <div className="approvedRule-field">
                <div className="approvedRule-label">Tested By</div>
                <div className="approvedRule-value approvedRule-value--strong">
                  {approveORFailRulesLoading
                    ? "Loading..."
                    : approveORFailRulesData?.testing_information?.tested_by
                      ? approveORFailRulesData?.testing_information?.tested_by
                      : "-"}
                </div>
              </div>

              <div className="approvedRule-field approvedRule-field--full">
                <div className="approvedRule-label">Tested On</div>
                <div className="approvedRule-value">
                  {approveORFailRulesLoading
                    ? "Loading..."
                    : approveORFailRulesData?.testing_information?.tested_on
                      ? approveORFailRulesData?.testing_information?.tested_on
                      : "-"}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="approvedRule-card approvedRule-card--half">
          <div className="approvedRule-card-header">Approval Information</div>
          <div className="approvedRule-card-body">
            <div className="approvedRule-grid approvedRule-grid--tight">
              <div className="approvedRule-field">
                <div className="approvedRule-label">Status</div>
                <div className="approvedRule-value approvedRule-value--approved">
                  {approveORFailRulesLoading
                    ? "Loading..."
                    : approveORFailRulesData?.approval_information?.status
                      ? approveORFailRulesData?.approval_information?.status
                      : "-"}
                </div>
              </div>
              <div className="approvedRule-field">
                <div className="approvedRule-label">Approved By</div>
                <div className="approvedRule-value approvedRule-value--strong">
                  {approveORFailRulesLoading
                    ? "Loading..."
                    : approveORFailRulesData?.approval_information?.approved_by
                      ? approveORFailRulesData?.approval_information
                          ?.approved_by
                      : "-"}
                </div>
              </div>

              <div className="approvedRule-field approvedRule-field--full">
                <div className="approvedRule-label">Approved On</div>
                <div className="approvedRule-value">
                  {approveORFailRulesLoading
                    ? "Loading..."
                    : approveORFailRulesData?.approval_information?.approved_on
                      ? approveORFailRulesData?.approval_information
                          ?.approved_on
                      : "-"}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* Footer actions */}
      <div className="approvedRule-footer">
        <button
          type="button"
          className="approvedRule-btn approvedRule-btn--ghost"
          onClick={handleBack}
        >
          Back to View Rules
        </button>
        <div className="approvedRule-footer-actions">
          {/* <button
            type="button"
            className="approvedRule-btn approvedRule-btn--ghost"
            onClick={handleRuleDraft}
          >
            Save as a draft
          </button> */}
          <button
            type="button"
            className="approvedRule-btn approvedRule-btn--primary"
            onClick={() => setShowPublishModal(true)} // CHANGED (was onPublish direct call)
          >
            Publish Rule
          </button>
        </div>
      </div>

      {/* ===== ADDED: Publish Rule Modal ===== */}
      {showPublishModal && (
        <div
          className="publishRuleModal-overlay"
          onClick={() => setShowPublishModal(false)}
        >
          <div
            className="publishRuleModal-dialog"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="publishRuleModal-header">
              <h2 className="publishRuleModal-title">Publish Rule?</h2>
              <button
                type="button"
                className="publishRuleModal-closeBtn"
                onClick={() => setShowPublishModal(false)}
                aria-label="Close"
              >
                &times;
              </button>
            </div>

            <p className="publishRuleModal-subtext">
              This rule is approved and ready to be published. Confirm
              publishing to make the rule available in the application.
            </p>

            <div className="publishRuleModal-infoBox">
              <div className="publishRuleModal-field">
                <div className="publishRuleModal-label">Rule ID</div>
                <div className="publishRuleModal-value">
                  {approveORFailRulesLoading
                    ? "Loading..."
                    : approveORFailRulesData?.rule_id
                      ? approveORFailRulesData?.rule_id
                      : "-"}
                </div>
              </div>

              <div className="publishRuleModal-divider" />

              <div className="publishRuleModal-field">
                <div className="publishRuleModal-label">Rule Description</div>
                <div className="publishRuleModal-value">
                  {approveORFailRulesLoading
                    ? "Loading..."
                    : approveORFailRulesData?.description
                      ? approveORFailRulesData.description
                      : "-"}
                </div>
              </div>

              <div className="publishRuleModal-divider" />

              <div className="publishRuleModal-field">
                <div className="publishRuleModal-label">Current Status</div>
                <div className="publishRuleModal-statusRow">
                  <span className="publishRuleModal-statusBar" />
                  <span className="publishRuleModal-statusDot" />
                  <span className="publishRuleModal-statusText">
                    {approveORFailRulesLoading
                      ? "Loading..."
                      : approveORFailRulesData?.approval_information?.status
                        ? approveORFailRulesData?.approval_information?.status
                        : "-"}
                  </span>
                </div>
              </div>
            </div>

            <div className="publishRuleModal-envSection">
              <div className="publishRuleModal-envTitle">
                PUBLISHING ENVIRONMENT
              </div>
              <div className="publishRuleModal-envSubtext">
                Select the environment where this rule should be published.
              </div>

            <div>
              <label className="publishRuleModal-envLabel">Environment</label>
            {deployedEnvs?.length > 0 && (
              <div className="environment-info-message">
                <InfoOutlinedIcon className="environment-info-icon" />
              <div>
              <strong>Already deployed</strong>
              <span>
                This rule has already been deployed to{" "}
                <strong>{deployedEnvs?.join(", ")}</strong>.{" "}
                These environments are unavailable for selection.
                </span>
              </div>
              </div>
            )}
              </div>
              <Select
                isMulti
                options={environmentOptions}
                value={environmentOptions.filter((option) =>
                  environment.includes(option.value),
                )}
                onChange={(selectedOptions) => {
                  const selectedEnvironment =
                    selectedOptions?.map((option) => option.value) || [];

                  setEnvironment(selectedEnvironment);

                  // Clear validation once user selects an environment
                  if (selectedEnvironment.length > 0) {
                    setEnvironmentError("");
                  }
                }}
                isOptionDisabled={(option) => environmentAvailable?.includes(option.value)}
                placeholder="Select environment..."
                isClearable
                closeMenuOnSelect={true}
              />
              {environmentError && (
                <div className="publishRuleModal-error">{environmentError}</div>
              )}
            </div>

            <div className="publishRuleModal-footer">
              <button
                type="button"
                className="publishRuleModal-btn publishRuleModal-btn--ghost"
                onClick={() => setShowPublishModal(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="publishRuleModal-btn publishRuleModal-btn--primary"
                onClick={handleConfirmPublish}
                disabled={!environment || environment.length === 0}

              >
                Publish Rule
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
